// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NavBar$Xuder from "./components/NavBar.bs.js";
import * as Compose$Xuder from "./pages/Compose.bs.js";
import * as HomePage$Xuder from "./pages/HomePage.bs.js";
import * as AboutPage$Xuder from "./pages/AboutPage.bs.js";
import * as CounterPage$Xuder from "./pages/CounterPage.bs.js";
import * as ReasonReactRouter from "reason-react/src/ReasonReactRouter.js";
import * as NotFoundPage$Xuder from "./pages/NotFoundPage.bs.js";
import * as XuderContext$Xuder from "./context/XuderContext.bs.js";

function App(Props) {
  var url = ReasonReactRouter.useUrl(undefined, /* () */0);
  var match = url[/* path */0];
  var tmp;
  var exit = 0;
  if (match) {
    switch (match[0]) {
      case "about" :
          if (match[1]) {
            exit = 1;
          } else {
            tmp = React.createElement(AboutPage$Xuder.make, { });
          }
          break;
      case "compose" :
          if (match[1]) {
            exit = 1;
          } else {
            tmp = React.createElement(Compose$Xuder.make, { });
          }
          break;
      case "counter" :
          if (match[1]) {
            exit = 1;
          } else {
            tmp = React.createElement(CounterPage$Xuder.make, { });
          }
          break;
      default:
        exit = 1;
    }
  } else {
    tmp = React.createElement(HomePage$Xuder.make, { });
  }
  if (exit === 1) {
    tmp = React.createElement(NotFoundPage$Xuder.make, { });
  }
  return React.createElement(XuderContext$Xuder.make, {
              children: null
            }, tmp, React.createElement(NavBar$Xuder.make, { }));
}

var make = App;

export {
  make ,
  
}
/* react Not a pure module */
